import i18next from 'i18next';
import { inicializarInternacionalizacao } from '../localizacao/cookieConsent/cookieConsent';

const _COOKIE_NAME = 'empregare_cookie_consent';
const _COOKIE_DAYS = 365;
const _MODAL_ID = 'modal-cookie-consent';

// --- Helpers de cookie (cross-subdomínio) ---

const _getDomain = () => {
    const h = window.location.hostname;
    if (h === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(h)) return h;
    const parts = h.split('.');
    return parts.length >= 2 ? '.' + parts.slice(-2).join('.') : h;
};

const _setCookie = (value) => {
    const exp = new Date();
    exp.setDate(exp.getDate() + _COOKIE_DAYS);
    document.cookie = _COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(value)) +
        ';expires=' + exp.toUTCString() + ';path=/;domain=' + _getDomain() + ';SameSite=Lax';
};

const _getCookie = () => {
    const pattern = new RegExp('(?:^|; )' + _COOKIE_NAME.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)');
    const m = document.cookie.match(pattern);
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch { return null; }
};

const _jaRespondeu = () => _getCookie() !== null;

const _getPrefs = () => {
    const c = _getCookie();
    return { f: c ? !!c.f : false, a: c ? !!c.a : false, m: c ? !!c.m : false };
};

const _salvar = ({ f, a, m }) => _setCookie({ v: 1, f, a, m });
const _aceitarTodos = () => _salvar({ f: true, a: true, m: true });
const _recusarNaoEssenciais = () => _salvar({ f: false, a: false, m: false });

// --- Banner ---

const _fecharBanner = () => {
    const el = document.getElementById('cookie-consent-banner');
    if (!el) return;
    el.classList.remove('cookie-consent-visivel');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
};

const _renderizarBanner = () => {
    const culture = typeof CULTURE_EMPREGARE !== 'undefined' ? CULTURE_EMPREGARE : 'pt_BR';
    const el = document.createElement('div');
    el.id = 'cookie-consent-banner';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', i18next.t('ModalTitulo'));
    el.innerHTML =
        '<div class="d-flex flex-wrap align-items-center gap-3 py-3 px-3 px-md-4">' +
            '<p class="mb-0 small flex-grow-1 text-white" style="flex-basis:260px">' +
                '<i class="bi bi-shield-lock-fill me-1 opacity-75"></i>' +
                i18next.t('BannerTexto') + ' ' +
                '<a href="/' + culture + '/pagina/cookies" class="link-light" target="_blank" rel="noopener">' + i18next.t('BannerSaibaMais') + '</a>.' +
            '</p>' +
            '<div class="d-flex align-items-center gap-3 ms-auto flex-shrink-0">' +
                '<button type="button" id="cookie-btn-configurar" class="btn btn-sm btn-link px-0 link-light text-decoration-none">' + i18next.t('BtnConfigurar') + '</button>' +
                '<button type="button" id="cookie-btn-recusar" class="btn btn-sm btn-outline-light">' +
                    '<span class="d-none d-sm-inline">' + i18next.t('BtnRecusarCompleto') + '</span>' +
                    '<span class="d-sm-none">' + i18next.t('BtnRecusar') + '</span>' +
                '</button>' +
                '<button type="button" id="cookie-btn-aceitar" class="btn btn-sm btn-light">' + i18next.t('BtnAceitarTodos') + '</button>' +
            '</div>' +
        '</div>';

    document.body.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('cookie-consent-visivel')));

    document.getElementById('cookie-btn-aceitar').addEventListener('click', () => { _aceitarTodos(); _fecharBanner(); });
    document.getElementById('cookie-btn-recusar').addEventListener('click', () => { _recusarNaoEssenciais(); _fecharBanner(); });
    document.getElementById('cookie-btn-configurar').addEventListener('click', () => cookieConsent.abrirConfiguracoes());
};

// --- Modal de configurações ---

const _categoriaItem = (id, titulo, descricao, fixo) => {
    const direita = fixo
        ? '<span class="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle fw-normal">' + i18next.t('SempreAtivo') + '</span>'
        : '<div class="form-check form-switch mb-0" onclick="event.stopPropagation()">' +
              '<input class="form-check-input" type="checkbox" role="switch" id="cookie-chk-' + id + '">' +
          '</div>';

    return '<div class="cookie-categoria border-bottom">' +
        '<button type="button" class="d-flex align-items-center w-100 py-3 px-3 bg-transparent border-0 text-start gap-2" ' +
            'data-bs-toggle="collapse" data-bs-target="#cookie-col-' + id + '" ' +
            'aria-expanded="false" aria-controls="cookie-col-' + id + '">' +
            '<i class="bi bi-chevron-right cookie-chevron small text-muted flex-shrink-0"></i>' +
            '<span class="fw-semibold flex-grow-1 small">' + titulo + '</span>' +
            '<div class="ms-2 flex-shrink-0">' + direita + '</div>' +
        '</button>' +
        '<div id="cookie-col-' + id + '" class="collapse">' +
            '<p class="small text-muted px-3 pb-3 mb-0">' + descricao + '</p>' +
        '</div>' +
    '</div>';
};

const _renderizarModal = () => {
    if (document.getElementById(_MODAL_ID)) return;

    const culture = typeof CULTURE_EMPREGARE !== 'undefined' ? CULTURE_EMPREGARE : 'pt_BR';
    const el = document.createElement('div');
    el.id = _MODAL_ID;
    el.className = 'modal fade';
    el.tabIndex = -1;
    el.setAttribute('aria-labelledby', 'cookie-modal-titulo');
    el.setAttribute('aria-hidden', 'true');

    el.innerHTML =
        '<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable cookie-consent-modal-dialog">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<h5 class="modal-title fs-6 fw-bold" id="cookie-modal-titulo">' + i18next.t('ModalTitulo') + '</h5>' +
                    '<button type="button" class="fechar-modal" data-bs-dismiss="modal" aria-label="' + i18next.t('ModalBtnFechar') + '"><i class="bi bi-x-circle fs-5"></i></button>' +
                '</div>' +
                '<div class="modal-body p-0">' +
                    '<ul class="nav nav-tabs px-3" role="tablist">' +
                        '<li class="nav-item" role="presentation">' +
                            '<button class="nav-link active small py-2 px-3" data-bs-toggle="tab" data-bs-target="#cookie-tab-prefs" type="button" role="tab">' + i18next.t('TabPreferencias') + '</button>' +
                        '</li>' +
                        '<li class="nav-item" role="presentation">' +
                            '<button class="nav-link small py-2 px-3" data-bs-toggle="tab" data-bs-target="#cookie-tab-politica" type="button" role="tab">' + i18next.t('TabPolitica') + '</button>' +
                        '</li>' +
                    '</ul>' +
                    '<div class="tab-content">' +
                        '<div class="tab-pane fade show active" id="cookie-tab-prefs" role="tabpanel">' +
                            '<p class="small text-muted px-3 pt-3 pb-2 mb-0">' + i18next.t('PrefsDescricao') + '</p>' +
                            _categoriaItem('necessarios', i18next.t('CategoriaNecessariosNome'), i18next.t('CategoriaNecessariosDesc'), true) +
                            _categoriaItem('funcionais', i18next.t('CategoriaFuncionaisNome'), i18next.t('CategoriaFuncionaisDesc'), false) +
                            _categoriaItem('analiticos', i18next.t('CategoriaAnaliticosNome'), i18next.t('CategoriaAnaliticosDesc'), false) +
                            _categoriaItem('marketing', i18next.t('CategoriaMarketingNome'), i18next.t('CategoriaMarketingDesc'), false) +
                        '</div>' +
                        '<div class="tab-pane fade p-3" id="cookie-tab-politica" role="tabpanel">' +
                            '<p class="small text-muted mb-0">' + i18next.t('PoliticaTexto') + ' ' +
                                '<a href="/' + culture + '/pagina/privacidade" target="_blank" rel="noopener">' + i18next.t('LinkPoliticaPrivacidade') + '</a>' +
                                ' · ' +
                                '<a href="/' + culture + '/pagina/cookies" target="_blank" rel="noopener">' + i18next.t('LinkPoliticaCookies') + '</a>.' +
                            '</p>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="modal-footer border-top gap-2">' +
                    '<button type="button" class="btn btn-outline-secondary btn-sm" id="cookie-modal-recusar">' + i18next.t('BtnRecusarCompleto') + '</button>' +
                    '<button type="button" class="btn btn-primary btn-sm ms-auto" id="cookie-modal-salvar">' + i18next.t('BtnSalvarPreferencias') + '</button>' +
                    '<button type="button" class="btn btn-primary btn-sm" id="cookie-modal-aceitar">' + i18next.t('BtnAceitarTodos') + '</button>' +
                '</div>' +
            '</div>' +
        '</div>';

    document.body.appendChild(el);

    el.addEventListener('show.bs.modal', () => {
        const prefs = _getPrefs();
        const chkF = document.getElementById('cookie-chk-funcionais');
        const chkA = document.getElementById('cookie-chk-analiticos');
        const chkM = document.getElementById('cookie-chk-marketing');
        if (chkF) chkF.checked = prefs.f;
        if (chkA) chkA.checked = prefs.a;
        if (chkM) chkM.checked = prefs.m;
    });

    const _fecharModal = () => bootstrap.Modal.getInstance(el)?.hide();

    document.getElementById('cookie-modal-aceitar').addEventListener('click', () => {
        _aceitarTodos(); _fecharBanner(); _fecharModal();
    });
    document.getElementById('cookie-modal-recusar').addEventListener('click', () => {
        _recusarNaoEssenciais(); _fecharBanner(); _fecharModal();
    });
    document.getElementById('cookie-modal-salvar').addEventListener('click', () => {
        _salvar({
            f: document.getElementById('cookie-chk-funcionais')?.checked ?? false,
            a: document.getElementById('cookie-chk-analiticos')?.checked ?? false,
            m: document.getElementById('cookie-chk-marketing')?.checked ?? false,
        });
        _fecharBanner();
        _fecharModal();
    });
};

// --- API pública ---

export const cookieConsent = {
    init() {
        if (window.EMPREGARE_HIDE_COOKIE_CONSENT) return;

        inicializarInternacionalizacao();

        _renderizarModal();

        if (!_jaRespondeu()) _renderizarBanner();

        document.addEventListener('click', (e) => {
            if (e.target.closest('.btn-configuracoes-cookies')) {
                this.abrirConfiguracoes();
            }
        });
    },
    abrirConfiguracoes() {
        const modal = document.getElementById(_MODAL_ID);
        if (!modal) return;
        (bootstrap.Modal.getInstance(modal) || new bootstrap.Modal(modal)).show();
    },
    respondeu() {
        return _jaRespondeu();
    },
    getPreferencias() {
        return _getPrefs();
    },
    aceitouTodos() {
        const c = _getCookie();
        return c !== null && c.f && c.a && c.m;
    }
};
